import { useFela } from 'react-fela';
import * as PropTypes from 'prop-types';

import { utils as uploaderUtils } from 'modules/uploader';

import ImageActions from '../ImageActions';

import rule from './Image.rule';

const options = {
    width: '250',
    height: '250',
};

const Image = ({ id, firestoreId, url }) => {
    const { css } = useFela({
        imageUrl: uploaderUtils.buildSource(id, options),
    });
    return <div className={css(rule)}>{firestoreId && <ImageActions firestoreId={firestoreId} url={url} />}</div>;
};

Image.propTypes = {
    id: PropTypes.string.isRequired,
    firestoreId: PropTypes.string,
    url: PropTypes.string.isRequired,
};

Image.defaultProps = {
    firestoreId: null,
};

export default Image;
